import React from "react";
import AppConstants from "../../constants/AppConstants";
import StyleUtils from "../../utils/StyleUtils";

const getDashArrayValue = (lineWidth, thickness, dashSize, dashSpacing) => {
  const singlePattern = dashSize + dashSpacing;
  const numberOfPatterns = Math.floor(lineWidth / singlePattern);
  const adjustedPattern =
    lineWidth /
    (numberOfPatterns + (!dashSize ? thickness / singlePattern : dashSize / singlePattern));
  return `${adjustedPattern * (dashSize / singlePattern)} ${
    adjustedPattern * (dashSpacing / singlePattern)
  }`;
};

const Line = ({ elemProps, theme, content }) => {
  const styleDefaults = {
    width: "100%",
    height: "100%",
    verticalAlign: "top",
    overflow: "visible",
  };
  const color = StyleUtils.getColorValue(elemProps.get("c", content.get("c", "colors-0")), theme);
  const thickness =
    elemProps.get("h") > 0 ? elemProps.get("h") : AppConstants.DEFAULT_LINE_PROPERTIES.h;
  const length = elemProps.get("w");
  const strokeLinecap =
    elemProps.get("lineCap", AppConstants.DEFAULT_LINE_PROPERTIES.lineCap) === "round"
      ? "round"
      : "butt";
  const lineStyle = elemProps.get("lineStyle", AppConstants.DEFAULT_LINE_PROPERTIES.lineStyle);
  const dotted = lineStyle === "dotted";
  const roundedSolid = strokeLinecap === "round" && lineStyle === "solid";
  const isRound = dotted || roundedSolid;
  const dashWidth = dotted ? 0 : elemProps.get("dW", AppConstants.DEFAULT_LINE_PROPERTIES.dW);
  const spacing = elemProps.get("dF", AppConstants.DEFAULT_LINE_PROPERTIES.dF);
  const dashArrayValue =
    lineStyle === "solid" ? "none" : getDashArrayValue(length, thickness, dashWidth, spacing);

  const shadowStyle = StyleUtils.getShadowStyle(elemProps, theme, "svg");
  const style = { ...styleDefaults, ...shadowStyle };

  return (
    <div style={{ padding: `${thickness / 2}px ${isRound ? thickness / 2 : 0}px ` }}>
      <svg stroke={color} style={style}>
        <line
          x2={length - (roundedSolid ? thickness : 0)}
          strokeLinecap={dotted || roundedSolid ? "round" : "butt"}
          strokeDasharray={dashArrayValue}
          pathLength={length}
          strokeWidth={thickness}
        />
      </svg>
    </div>
  );
};

export default Line;
